import { Container, Center, Text, Button } from '@chakra-ui/react'
import { HeadingPages } from '../../../../components/HeadingPages'

export function ErrorState({ onRetry }) {
  return (
    <div>
      <HeadingPages name={'CONTROLE DE PRODUÇÃO'} bgColor={'#378bbf'} />
      <Container maxW="container.xl" py={6} my={16}>
        <Center h="200px" flexDirection="column">
          <Text color="red.500" fontSize="lg" mb={4}>
            Erro ao carregar dados do pedido
          </Text>
          <Button onClick={onRetry} colorScheme="blue">
            Voltar para Lista de Pedidos
          </Button>
        </Center>
      </Container>
    </div>
  )
}
